/* eslint-disable */

import React from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import Input, { InputLabel } from 'material-ui/Input';
import { enums } from '../../src/enums/';
import {
  FormLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
} from 'material-ui/Form';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';
import MenuItem from 'material-ui/Menu/MenuItem';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Switch from 'material-ui/Switch';
import { withRouter } from 'react-router';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import userIcon from '../assets/images/icons/person.png';
import plusIcon from '../assets/images/icons/plus.png';
import trashIcon from '../assets/images/icons/trash.png';
import deleteIcon from '../assets/images/icons/delete.png';
import List from 'material-ui/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemSecondaryAction from 'material-ui/List/ListItemSecondaryAction';
import ListItemText from 'material-ui/List/ListItemText';

import Typography from 'material-ui/Typography';

import { translate } from 'react-i18next';

import {
  surnameChanged,
  organizationChanged,
  rolesChanged,
  toggleAdminRoleChanged,
  toggleUserAdminRoleChanged,
  toggleAssetAdminRoleChanged,
  toggleAgreementAdminRoleChanged,
  toggleAssetManagerRoleChanged,
  toggleTraderRoleChanged,
  toggleMatcherRoleChanged,
  activeUserChanged,
  addressChanged,
  createUserStart,
  uploadUserPicture,
  userPictureChanged,
  updateUserStart,
  getUserStart,
  getUserFormStart,
  resetCurrentUser,
  getConsumptionSitesList,
  getConsumptionSitesByOrganization,
  userNameChanged,
  emailChanged,
  lastNameChanged,
  phoneNumberChanged,
  typeChanged,
  firstNameChanged,
  realAccountChanged,
  deliveriesRoleChanged,
  rolesListChanged,
  getOrganizations,
  updateFormUserConsumingAssetList,
} from '../actions';
import { constants } from '../constants';
import { checkUserIsAdmin } from '../utils/user/checkAdmin/CheckAdmin';
import ListSubheader from 'material-ui/List/ListSubheader';

/**
 * Common component import
 */
import LoadingCircle from '../../src/components/commons/LoadingCircle';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
    margin: 20,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class FormUsers extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  state = {
    address: '',
    allConsAssetsList: [],
    availableConsAssetsList: [],
    relatedConsAssetsList: [],
    loadingConsAssets: false,
    organizationId: '',
  };

  currentRole = currentUser => {
    let currentRolesList = currentUser.app_metadata.roles.filter(role => {
      return role != enums.UserRole.HAS_DELIVERIES;
    });
    return currentRolesList[0];
  };

  componentDidMount = async () => {
    const {
      currentUser,
      isAuthenticated,
      user,
      match: { params },
    } = this.props;

    await this.populateAllConsAssetsList();

    let userId = user.user_id.split('|')[1];

    if (checkUserIsAdmin(isAuthenticated, user) || userId === params.userId) {
      await this.props.getOrganizations();

      if (params.userId) {
        // Update mode
        let organizationId = '';

        const user = await this.props.getUserFormStart(params.userId);
        const { currentUser } = this.props;
        currentUser &&
          currentUser.user_metadata &&
          currentUser.user_metadata.organization &&
          currentUser.user_metadata.organization.type ===
            enums.OrganizationTypes.CUSTOMER &&
          currentUser.user_metadata.organization._id &&
          this.props.getConsumptionSitesByOrganization(
            currentUser.user_metadata.organization._id
          );

        if (user.user_metadata.organization) {
          organizationId = user.user_metadata.organization._id;
        }

        this.setState({
          organizationId: organizationId,
        });

        this.setAvailableAndRelatedConsAssetsList(user, params.userId);
      } else {
        // Create mode
        this.props.resetCurrentUser();
        this.setAvailableAndRelatedConsAssetsList(currentUser, '');

        this.setState({
          organizationId: '',
        });
      }
    } else {
      this.props.history.push('/');
    }
  };

  parseGoogleResponse = components => {
    const formattedResult = {
      country: '',
      region: '',
      zip: '',
      city: '',
      street: '',
      houseNumber: '',
      gpsLatitude: '',
      gpsLongitude: '',
    };
    return getLatLng(components).then(gpsCoords => {
      formattedResult.gpsLatitude = gpsCoords.lat;
      formattedResult.gpsLongitude = gpsCoords.lng;

      components.address_components.map(component => {
        component.types.map(type => {
          if (type === 'route') {
            formattedResult.street = component.long_name;
          }
          if (type === 'street_number') {
            formattedResult.houseNumber = component.long_name;
          }
          if (type === 'locality') {
            formattedResult.city = component.long_name;
          }
          if (type === 'administrative_area_level_1') {
            formattedResult.region = component.long_name;
          }
          if (type === 'country') {
            formattedResult.country = component.long_name;
          }
          if (type === 'postal_code') {
            formattedResult.zip = component.long_name;
          }
        });
      });
      return formattedResult;
    });
  };

  handleFirstNameChange = () => event => {
    this.props.firstNameChanged(event.target.value);
  };

  handleLastNameChange = () => event => {
    this.props.lastNameChanged(event.target.value);
  };

  handleUserNameChange = () => event => {
    this.props.userNameChanged(event.target.value);
  };

  handleDeliveriesRoleChange = () => event => {
    this.props.deliveriesRoleChanged(this.props.currentUser);
  };

  handleOrganizationChange = () => event => {
    const { currentUser } = this.props;

    let organization = this.props.organizations.find(org => {
      return org._id === event.target.value;
    });

    if (organization) {
      this.setState({
        organizationId: organization._id,
      });

      let role = enums.UserRole.CUSTOMER;

      if (organization.type === enums.OrganizationTypes.TEO)
        role = enums.UserRole.SUPER_ADMIN;
      if (organization.type === enums.OrganizationTypes.UTILITY)
        role = enums.UserRole.ADMIN;
      if (organization.type === enums.OrganizationTypes.CUSTOMER)
        role = enums.UserRole.CUSTOMER;

      this.props.rolesListChanged(role, currentUser);
    } else {
      this.setState({
        organizationId: '',
      });

      this.props.rolesListChanged(null, currentUser);
    }
    this.props.organizationChanged(organization);
    if (organization.type === enums.OrganizationTypes.CUSTOMER) {
      this.props.getConsumptionSitesByOrganization(organization._id);
    }
  };

  handlePhoneNumberChange = () => event => {
    this.props.phoneNumberChanged(event.target.value);
  };

  handleEmailChange = () => event => {
    this.props.emailChanged(event.target.value);
  };

  handleRoleChanged = () => event => {
    const { currentUser } = this.props;
    this.props.rolesListChanged(event.target.value, currentUser);
  };

  handleRolesChange = () => event => {
    this.props.rolesChanged(event.target.value);
  };

  handleRealAccountChange = () => event => {
    console.log(
      'handleRealAccountChange event.target.checked',
      event.target.checked
    );
    this.props.realAccountChanged(event.target.checked);
  };

  handleAddressChange = address => {
    this.setState({ address });
  };

  handleAddressSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        return this.parseGoogleResponse(results[0]);
      })
      .then(formattedAddress => {
        let fullAddress = formattedAddress.houseNumber + ' ';
        fullAddress += formattedAddress.street
          ? formattedAddress.street + ', '
          : '';
        fullAddress += formattedAddress.zip ? formattedAddress.zip + ', ' : '';
        fullAddress += formattedAddress.city
          ? formattedAddress.city + ', '
          : '';
        fullAddress += formattedAddress.region
          ? formattedAddress.region + ', '
          : '';
        fullAddress += formattedAddress.country
          ? formattedAddress.country + ' '
          : '';

        this.setState({ address: fullAddress });
        this.props.addressChanged(formattedAddress);
      })
      .catch(error => console.error('Error', error));
  };

  handleButtonLogout = () => {
    if (!this.props.loading) {
      this.props.logoutStart();
    }
  };

  populateAllConsAssetsList = async () => {
    this.state.allConsAssetsList = await getConsumptionSitesList();

    this.setState({
      allConsAssetsList: this.state.allConsAssetsList,
    });
  };

  onAddAssetClicked = consAsset => {
    const index = this.state.availableConsAssetsList.indexOf(consAsset);
    this.state.availableConsAssetsList.splice(index, 1);
    this.setState({
      availableConsAssetsList: this.state.availableConsAssetsList,
    });
    this.state.relatedConsAssetsList.push(consAsset);
    this.setState({ relatedConsAssetsList: this.state.relatedConsAssetsList });
  };

  onDeleteAssetClicked = consAsset => {
    const index = this.state.relatedConsAssetsList.indexOf(consAsset);
    this.state.relatedConsAssetsList.splice(index, 1);
    this.setState({ relatedConsAssetsList: this.state.relatedConsAssetsList });
    this.state.availableConsAssetsList.push(consAsset);
    this.setState({
      availableConsAssetsList: this.state.availableConsAssetsList,
    });
  };

  renderAvailableConsumingAssets() {
    const { classes } = this.props;
    if (this.state.loadingConsAssets)
      <LoadingCircle type="empty" classes={classes} />;

    return (
      <List dense={false}>
        {this.state.availableConsAssetsList.map(consAsset => {
          return (
            <ListItem key={'available-' + consAsset.name}>
              <ListItemText primary={consAsset.displayedName} />
              <ListItemSecondaryAction>
                <Button
                  onClick={() => {
                    this.onAddAssetClicked(consAsset);
                  }}
                >
                  <img src={plusIcon} style={{ maxHeight: 20 }} />
                </Button>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    );
  }

  renderRelatedConsumingAssets = () => {
    const { classes } = this.props;
    if (this.state.loadingConsAssets)
      <LoadingCircle type="empty" classes={classes} />;
    return (
      <List dense={false}>
        {this.state.relatedConsAssetsList.map(consAsset => {
          return (
            <ListItem key={'related-' + consAsset.name}>
              <ListItemText primary={consAsset.displayedName} />
              <ListItemSecondaryAction>
                <Button
                  onClick={() => {
                    this.onDeleteAssetClicked(consAsset);
                  }}
                >
                  <img src={deleteIcon} style={{ maxHeight: 20 }} />
                </Button>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    );
  };

  setAvailableAndRelatedConsAssetsList = (currentUser, currentUserId) => {
    this.setState({
      loadingConsAssets: true,
    });
    let availableConsAssetsList;
    let relatedConsAssetsList;
    if (currentUserId !== '') {
      availableConsAssetsList = this.state.allConsAssetsList.filter(
        consAsset => {
          if (!currentUser.user_metadata.consumingSites.includes(consAsset.id))
            return consAsset;
        }
      );
      relatedConsAssetsList = this.state.allConsAssetsList.filter(consAsset => {
        if (currentUser.user_metadata.consumingSites.includes(consAsset.id))
          return consAsset;
      });
    } else {
      availableConsAssetsList = this.state.allConsAssetsList;
      relatedConsAssetsList = this.state.relatedConsAssetsList;
    }
    this.setState({
      loadingConsAssets: false,
      availableConsAssetsList: availableConsAssetsList,
      relatedConsAssetsList: relatedConsAssetsList,
    });
  };

  deliveriesRoleExists = currentUser => {
    let index = currentUser.app_metadata.roles.indexOf(
      enums.UserRole.HAS_DELIVERIES
    );
    if (index > -1) return true;
    else return false;
  };

  onDrop = async file => {
    this.props.uploadUserPicture(file, this.props.currentUser._id);
  };

  handlePictureChange = event => {
    this.props.userPictureChanged(event.target.files[0]);
  };

  isOneFieldNotCompleted() {
    return (
      !this.props.currentUser.user_metadata ||
      !this.props.currentUser.user_metadata.firstname ||
      !this.props.currentUser.user_metadata.lastname ||
      !this.props.currentUser.user_metadata.username ||
      !this.props.currentUser.email ||
      !this.props.currentUser.user_metadata.phoneNumber ||
      !this.state.organizationId
    );
  }

  addRelatedConsumingAsset(consumingAsset) {
    const { currentUser } = this.props;
    currentUser.user_metadata.consumingAssets.push(consumingAsset);
    this.props.updateFormUserConsumingAssetList(currentUser);
  }

  removeRelatedConsumingAsset(consumingAsset) {
    const { currentUser } = this.props;
    currentUser.user_metadata.consumingAssets = currentUser.user_metadata.consumingAssets.filter(
      consAsset => {
        return consAsset._id !== consumingAsset._id;
      }
    );
    this.props.updateFormUserConsumingAssetList(currentUser);
  }

  render() {
    const {
      classes,
      currentUser,
      loading,
      loadingForm,
      organizations,
      localUserPicture,
      user,
      isAuthenticated,
      match: { params },
      t,
      cookies,
    } = this.props;

    let csrfToken = cookies.cookies._csrf;

    if (loading || loadingForm || !organizations || organizations.length < 1) {
      return (
        <div className={classes.root}>
          <LoadingCircle type="empty" classes={classes} />
        </div>
      );
    }
    let updatingUser = false;
    if (params.userId) {
      updatingUser = true;
    }
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });
    if (loadingForm || !currentUser) {
      <LoadingCircle type="empty" classes={classes} />;
    }
    if (updatingUser && !currentUser.app_metadata) {
      <LoadingCircle type="empty" classes={classes} />;
    }
    let fullAddress = currentUser.number + ' ';
    fullAddress += currentUser.street ? currentUser.street + ', ' : '';
    fullAddress += currentUser.zip ? currentUser.zip + ', ' : '';
    fullAddress += currentUser.city ? currentUser.city + ', ' : '';
    fullAddress += currentUser.region ? currentUser.region + ', ' : '';
    fullAddress += currentUser.country ? currentUser.country + ' ' : '';

    let userSelectedPicture = false;

    if (
      currentUser &&
      currentUser.user_metadata &&
      currentUser.user_metadata.pictureFileName &&
      !localUserPicture
    ) {
      userSelectedPicture =
        process.env.REACT_APP_API_URL +
        '/static/users/' +
        currentUser.user_metadata.pictureFileName;
    } else if (localUserPicture) {
      try {
        userSelectedPicture = URL.createObjectURL(localUserPicture);
      } catch (err) {
        console.log(err);
      }
    }

    let displayLightForm = true;
    let userId = user.user_id.split('|')[1];
    if (checkUserIsAdmin(isAuthenticated, user)) {
      displayLightForm = false;
    }

    if (
      !checkUserIsAdmin(isAuthenticated, user) &&
      params.userId &&
      userId !== params.userId
    ) {
      return (
        <div className={classes.root}>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Card className={classes.card}>
                <CardHeader title="Unauthorized" />
              </Card>
            </Grid>
          </Grid>
        </div>
      );
    }

    let customerOrganizationConsumingAssets =
      currentUser && currentUser.organizationConsumingAssets
        ? currentUser.organizationConsumingAssets
        : [];
    let userRelatedConsumingAssets =
      currentUser &&
      currentUser.user_metadata &&
      currentUser.user_metadata.consumingAssets &&
      currentUser.user_metadata.consumingAssets.length > 0
        ? currentUser.user_metadata.consumingAssets
        : [];
    let availableConsumingAssets = customerOrganizationConsumingAssets.filter(
      consumingAsset => {
        let isRelatedToUser = false;
        userRelatedConsumingAssets.map(consAsset => {
          if (consAsset.displayedName === consumingAsset.displayedName)
            isRelatedToUser = true;
        });
        return !isRelatedToUser;
      }
    );

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={userIcon} style={{ maxHeight: 20 }} />}
                title="User information"
              />
              <CardContent>
                <form style={{ width: '100%' }}>
                  <div>
                    <input type="hidden" name="_csrf" value={{ csrfToken }} />
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-first-name">
                        First name
                      </InputLabel>
                      <Input
                        id="adornment-first-name"
                        type="text"
                        value={
                          currentUser.user_metadata &&
                          currentUser.user_metadata.firstname
                            ? currentUser.user_metadata.firstname
                            : ''
                        }
                        autoComplete="first name"
                        onChange={this.handleFirstNameChange()}
                      />
                    </FormControl>

                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-last-name">
                        Last name
                      </InputLabel>
                      <Input
                        id="adornment-last-name"
                        type="text"
                        value={
                          currentUser.user_metadata &&
                          currentUser.user_metadata.lastname
                            ? currentUser.user_metadata.lastname
                            : ''
                        }
                        autoComplete="last name"
                        onChange={this.handleLastNameChange()}
                      />
                    </FormControl>
                    {!displayLightForm && (
                      <FormControl
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <InputLabel htmlFor="adornment-username">
                          Username
                        </InputLabel>
                        <Input
                          id="adornment-usename"
                          type="text"
                          value={
                            currentUser.user_metadata &&
                            currentUser.user_metadata.username
                              ? currentUser.user_metadata.username
                              : ''
                          }
                          autoComplete="surname"
                          onChange={this.handleUserNameChange()}
                        />
                      </FormControl>
                    )}
                  </div>
                  <div>
                    {!displayLightForm && (
                      <FormControl
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <InputLabel htmlFor="adornment-email">
                          E-mail
                        </InputLabel>
                        <Input
                          id="adornment-email"
                          type="text"
                          value={
                            currentUser && currentUser.email
                              ? currentUser.email
                              : ''
                          }
                          autoComplete="email"
                          onChange={this.handleEmailChange()}
                        />
                      </FormControl>
                    )}
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="phone-number">
                        Phone number
                      </InputLabel>
                      <Input
                        id="phone-number"
                        type="text"
                        value={
                          currentUser.user_metadata &&
                          currentUser.user_metadata.phoneNumber
                            ? currentUser.user_metadata.phoneNumber
                            : ''
                        }
                        autoComplete="phone number"
                        onChange={this.handlePhoneNumberChange()}
                      />
                    </FormControl>
                    {!displayLightForm && (
                      <FormControl
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <TextField
                          id="select-organization"
                          select
                          label={t('Organization')}
                          value={this.state.organizationId}
                          onChange={this.handleOrganizationChange()}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          style={{ minWidth: 168 }}
                        >
                          <MenuItem value="">-</MenuItem>
                          {organizations.map(organization => (
                            <MenuItem
                              key={organization._id}
                              value={organization._id}
                            >
                              {organization.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    )}
                  </div>
                  {false && (
                    <div>
                      <TextField
                        id="select-user-role"
                        select
                        label="User role"
                        className={classes.textField}
                        value={
                          currentUser.app_metadata &&
                          currentUser.app_metadata.roles
                            ? this.currentRole(currentUser)
                            : ' '
                        }
                        onChange={this.handleRoleChanged()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        {constants.UserRoles.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>
                  )}

                  <div>
                    {!displayLightForm && (
                      <FormControl component="fieldset" style={{ margin: 20 }}>
                        <FormLabel component="legend">
                          2nd Level Certification Module (bêta)
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={
                                  currentUser.app_metadata
                                    ? this.deliveriesRoleExists(currentUser)
                                    : false
                                }
                                onChange={this.handleDeliveriesRoleChange()}
                              />
                            }
                            label={
                              currentUser.app_metadata &&
                              this.deliveriesRoleExists(currentUser)
                                ? 'Yes'
                                : 'No'
                            }
                          />
                        </FormGroup>
                      </FormControl>
                    )}
                  </div>
                  {currentUser &&
                    currentUser.user_metadata &&
                    currentUser.user_metadata.organization &&
                    currentUser.user_metadata.organization.type ===
                      enums.OrganizationTypes.CUSTOMER && (
                      <Grid
                        item
                        xs={12}
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <Row>
                          <Col xs={6}>
                            <List dense>
                              <ListSubheader>
                                Available Consuming Assets
                              </ListSubheader>
                              {availableConsumingAssets.map(consAsset => (
                                <ListItem>
                                  <ListItemText
                                    primary={consAsset.displayedName}
                                  />
                                  <ListItemSecondaryAction>
                                    <Button
                                      onClick={() => {
                                        this.addRelatedConsumingAsset(
                                          consAsset
                                        );
                                      }}
                                    >
                                      <img
                                        src={plusIcon}
                                        style={{ maxHeight: 20 }}
                                      />
                                    </Button>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              ))}
                            </List>
                          </Col>
                          <Col xs={6}>
                            <List dense>
                              <ListSubheader>
                                Selected Consuming Assets
                              </ListSubheader>
                              <ListItem>
                                <ListItemText secondary="If none is selected, the user has unlimited access to all consumption sites affiliated to the organization." />
                              </ListItem>
                              {userRelatedConsumingAssets.map(consAsset => (
                                <ListItem>
                                  <ListItemText
                                    primary={consAsset.displayedName}
                                  />
                                  <ListItemSecondaryAction>
                                    <Button
                                      onClick={() => {
                                        this.removeRelatedConsumingAsset(
                                          consAsset
                                        );
                                      }}
                                    >
                                      <img
                                        src={trashIcon}
                                        style={{ maxHeight: 20 }}
                                      />
                                    </Button>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              ))}
                            </List>
                          </Col>
                        </Row>
                      </Grid>
                    )}

                  <Grid
                    item
                    xs={12}
                    className={classNames(classes.margin, classes.textField)}
                  >
                    <Row>
                      <Col>
                        <input
                          accept="image/*"
                          className={classes.input}
                          id="upload-button-file"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={this.handlePictureChange.bind(this)}
                          onDrop={this.onDrop.bind(this)}
                        />
                        <label htmlFor="upload-button-file">
                          <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            className={classes.button}
                            disabled={loading}
                            style={{
                              marginTop: 13,
                              border: '1px solid rgba(248,119,51, 0.5)',
                              borderRadius: 4,
                            }}
                          >
                            Select Picture
                          </Button>
                        </label>
                      </Col>
                      <Col style={{ marginLeft: 10 }}>
                        {userSelectedPicture && (
                          <img
                            src={userSelectedPicture}
                            style={{
                              height: 60,
                              width: 60,
                              borderRadius: '50%',
                            }}
                          />
                        )}
                        {!userSelectedPicture && (
                          <Typography
                            color="inherit"
                            variant="caption"
                            style={{ marginTop: 23 }}
                          >
                            No picture selected
                          </Typography>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 40 }}>
                      <Col>
                        <Button
                          variant="raised"
                          color="primary"
                          className={buttonClassname}
                          disabled={loading || this.isOneFieldNotCompleted()}
                          onClick={() => {
                            updatingUser
                              ? this.props.updateUserStart(
                                  params.userId,
                                  this.props.currentUser,
                                  this.props.history,
                                  this.state.relatedConsAssetsList,
                                  this.props.localUserPicture
                                )
                              : this.props.createUserStart(
                                  currentUser,
                                  this.props.history,
                                  this.state.relatedConsAssetsList,
                                  this.props.localUserPicture
                                );
                          }}
                        >
                          {updatingUser ? 'Update user' : 'Create user'}
                        </Button>
                        {loading && (
                          <LoadingCircle
                            type="buttonProgress"
                            classes={classes}
                          />
                        )}
                      </Col>
                    </Row>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

FormUsers.contextTypes = {
  router: PropTypes.object,
};

FormUsers.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  usersReducer,
  organizationsReducer,
  router,
  loginReducer,
}) => {
  const { currentUser, loading, loadingForm, localUserPicture } = usersReducer;
  const { location } = router;
  const { organizations } = organizationsReducer;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    currentUser,
    loading,
    loadingForm,
    location,
    isAuthenticated,
    username,
    user,
    organizations,
    localUserPicture,
  };
};

const mapDispatchToProps = {
  surnameChanged,
  organizationChanged,
  rolesChanged,
  toggleAdminRoleChanged,
  toggleUserAdminRoleChanged,
  toggleAssetAdminRoleChanged,
  toggleAgreementAdminRoleChanged,
  toggleAssetManagerRoleChanged,
  toggleTraderRoleChanged,
  toggleMatcherRoleChanged,
  activeUserChanged,
  addressChanged,
  createUserStart,
  updateUserStart,
  uploadUserPicture,
  userPictureChanged,
  getUserStart,
  getUserFormStart,
  resetCurrentUser,
  getConsumptionSitesList,
  getConsumptionSitesByOrganization,
  userNameChanged,
  emailChanged,
  lastNameChanged,
  phoneNumberChanged,
  typeChanged,
  firstNameChanged,
  realAccountChanged,
  deliveriesRoleChanged,
  rolesListChanged,
  getOrganizations,
  updateFormUserConsumingAssetList,
};

FormUsers = withStyles(styles, { name: 'FormUsers' })(FormUsers);
FormUsers = translate('translations')(FormUsers);
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(FormUsers))
);



// WEBPACK FOOTER //
// ./src/components/FormUsers.js